import moment from 'moment';
import { defineStore } from 'pinia';
import api from '@/services/api';

export const useUserStore = defineStore('user', {
  state: () => ({
    loading: false,
    user: {},
    limits: {},
    settings: {
      timezone: ''
    },
    loaded: false,
  }),
  actions: {
    async getUser(force) {
      if (!this.loaded || force) {
        try {
          const { user, user: { settings }, limits } = await api.user.me();
          this.user = user;
          this.limits = limits;
          this.settings.timezone = settings.timezone || moment.tz.guess();
          this.loaded = true;
        } catch (err) {
          console.log(err);
        }
      }
    },
    updateUser({ user, limits }) {
      this.user = user;
      this.limits = limits;
      if (user.timezone) this.settings.timezone = user.timezone;
    },
    clearStore() {
      this.$reset();
    },
  },
});
